import { IFlexMessageTemplate } from '@/utils/types'
import { NormApi } from './norm'

export class FlexMessageTemplateApi extends NormApi<IFlexMessageTemplate> {
  list = async (payload: IFlexMessageTemplate) => {
    const response = await this.axios.post('/v1/flex-message-templates/list', payload)
    return this.responseHandler(response)
  }

  single = async (id: string) => {
    const response = await this.axios.get(`/v1/flex-message-templates/${id}`)
    return this.responseHandler(response)
  }

  add = async (payload: IFlexMessageTemplate) => {
    const response = await this.axios.post('/v1/flex-message-templates', payload)
    return this.responseHandler(response)
  }

  update = async (payload: IFlexMessageTemplate) => {
    const { _id, ...updateData } = payload
    const response = await this.axios.put(`/v1/flex-message-templates/${_id}`, updateData)
    return this.responseHandler(response)
  }

  delete = async (id: string) => {
    const response = await this.axios.delete(`/v1/flex-message-templates/${id}`)
    return this.responseHandler(response)
  }
}

const flexMessageTemplateApi = new FlexMessageTemplateApi()
export default flexMessageTemplateApi
